<template>
    <div class="fullbooking">
        <UpcomingBookingComponent></UpcomingBookingComponent>
    </div>
</template>


<script>
    import UpcomingBookingComponent from '@/components/cust_components/cust_upcomingbookings_component.vue';

    export default {
        name: 'upcomingBooking',
        data() {
            return {
            }
        },
        components: {
            UpcomingBookingComponent
        }

    }
</script>